import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tip_title" }, "与星汉未来联系"),
  /*#__PURE__*/_createElementVNode("div", { class: "tip_text" }, "留下您的联系方式，我们将在1个工作日内和您联系")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: $data.modal.show,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($data.modal.show) = $event)),
    okText: "提交",
    closable: false,
    onOk: $options.handleOk,
    destroyOnClose: "",
    "confirm-loading": $data.modal.submitLoading,
    class: "modalFormCollection"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            lg: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "form",
                model: $data.form.data,
                rules: $data.form.rule,
                name: "FormCollection",
                "label-col": { span: 4 },
                "wrapper-col": { span: 20 },
                autocomplete: "off",
                onFinish: $options.onFinish,
                onFinishFailed: $options.onFinishFailed,
                layout: 
            _ctx.$Store.Public().isGridMatch('>=', _ctx.$Enum.GridEnum.MD)
              ? 'horizontal'
              : 'vertical'
          
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "real_name",
                    "has-feedback": "",
                    label: "姓名"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.real_name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.form.data.real_name) = $event)),
                        placeholder: "请填写姓名",
                        maxlength: _ctx.$Check.Constraint.RealNameMax,
                        "show-count": $data.form.data.real_name.length > 0,
                        "allow-clear": ""
                      }, {
                        default: _withCtx(() => [
                          _createCommentVNode(" <template #prefix>\n                <IdcardOutlined class=\"input_icon\" />\n              </template> ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "telphone",
                    "has-feedback": "",
                    label: "手机号"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.telphone,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.form.data.telphone) = $event)),
                        placeholder: "请填写手机号",
                        maxlength: _ctx.$Check.Constraint.Phone,
                        "show-count": $data.form.data.telphone.length > 0,
                        "allow-clear": ""
                      }, {
                        default: _withCtx(() => [
                          _createCommentVNode(" <template #prefix>\n                <TeamOutlined class=\"input_icon\" />\n              </template> ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "email",
                    "has-feedback": "",
                    label: "邮箱"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.email,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($data.form.data.email) = $event)),
                        placeholder: "请填写邮箱",
                        "allow-clear": ""
                      }, {
                        default: _withCtx(() => [
                          _createCommentVNode(" <template #prefix>\n                <TeamOutlined class=\"input_icon\" />\n              </template> ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "ent_name",
                    "has-feedback": "",
                    label: "企业/学校"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.ent_name,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.form.data.ent_name) = $event)),
                        placeholder: "请填写企业/学校",
                        maxlength: _ctx.$Check.Constraint.MaxX,
                        "show-count": $data.form.data.ent_name.length > 0,
                        "allow-clear": ""
                      }, {
                        default: _withCtx(() => [
                          _createCommentVNode(" <template #prefix>\n                <TeamOutlined class=\"input_icon\" />\n              </template> ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "position",
                    "has-feedback": "",
                    label: "职位"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: $data.form.data.position,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($data.form.data.position) = $event)),
                        placeholder: "请填写职位",
                        maxlength: _ctx.$Check.Constraint.MaxX,
                        "show-count": $data.form.data.position.length > 0,
                        "allow-clear": ""
                      }, {
                        default: _withCtx(() => [
                          _createCommentVNode(" <template #prefix>\n                <SolutionOutlined class=\"input_icon\" />\n              </template> ")
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "description",
                    label: "需求描述"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: $data.form.data.description,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($data.form.data.description) = $event)),
                        placeholder: "请填写需求描述",
                        maxlength: _ctx.$Check.Constraint.Max4X,
                        "show-count": true,
                        "allow-clear": ""
                      }, null, 8 /* PROPS */, ["value", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "other",
                    label: "其他"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: $data.form.data.other,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($data.form.data.other) = $event)),
                        placeholder: "请填写其他",
                        maxlength: _ctx.$Check.Constraint.Max4X,
                        "show-count": true,
                        "allow-clear": ""
                      }, null, 8 /* PROPS */, ["value", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["model", "rules", "onFinish", "onFinishFailed", "layout"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "onOk", "confirm-loading"]))
}